module.exports = __webpack_public_path__ + "img/eq-verdungos-hearty-cord.8ad29346.png";